import { Component, OnInit } from '@angular/core';
import { AnticipatedDateService } from './anticipated-date.service';

@Component({
  selector: 'app-anticipated-date',
  templateUrl: './anticipated-date.component.html',
  styleUrls: ['./anticipated-date.component.scss']
})
export class AnticipatedDateComponent implements OnInit {
  loading: boolean = true;
  new_data = 'false';
  anticipatedDateData: any;
  email: any;
  // anticipatedDateData = [
  //   {
  //     "NDA number": "208169",
  //     "Brand Name/Proprietary Name": "XURIDEN",
  //     "Active Ingredient": "URIDINE TRIACETATE",
  //     "Route of Administration": "ORAL",
  //     "Dosage forms": "GRANULE",
  //     "Anticipated Market Formation Date": {
  //       "value": "10/07/2023"
  //     }
  //   }
  // ]

  constructor(private AnticipatedDateService: AnticipatedDateService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getAmfdData()
  }

  getAmfdData() {
    this.AnticipatedDateService.getAmfdAllData(this.new_data, this.email).subscribe((response) => {
      this.anticipatedDateData = response["data"];
      console.log("resss", this.anticipatedDateData);
      this.loading = false;
    });
  }

  refreshData(status: string) {
    this.new_data = status;
    console.log("new data after", this.new_data);
    this.getAmfdData();
  }


}
